import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import * as EmailValidator from "email-validator";

import { UsernameCreds } from "../constants/constants";

export const useUsernameForgotPassword = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const [state, setState] = useState({
    input: "",
    status: "normal",
    error: "",
  });

  const handleInput = (e) => {
    setState({
      ...state,
      input: e.target.value,
    });
  };

  const handleSubmit = () => {
    if (EmailValidator.validate(state.input)) {
      if (state.input !== UsernameCreds.email) {
        setState({
          status: "error",
          error: "Username or email address not registered",
        });

        return;
      }
    } else if (state.input !== UsernameCreds.username) {
      setState({
        status: "error",
        error: "Username or email address not registered",
      });

      return;
    }

    setShowModal(true);
  };

  const handleBackToSignIn = () => {
    navigate("/login/username");
  };

  return {
    state,
    showModal,
    handleInput,
    handleSubmit,
    handleBackToSignIn,
  };
};
